// ─── Constants ────────────────────────────────────────────────────────────────

export const LEVELS = ['beginner', 'intermediate', 'advanced']

export const LEVEL_FA = { beginner: 'مبتدی', intermediate: 'متوسط', advanced: 'پیشرفته' }

export const STATUS_FA = { draft: 'پیش‌نویس', published: 'منتشرشده', archived: 'بایگانی' }

export const STATUS_CLS = {
  draft: 'bg-amber-100 text-amber-800',
  published: 'bg-green-100 text-green-800',
  archived: 'bg-slate-100 text-slate-500',
}

export const STATUS_ORDER = { draft: 0, published: 1, archived: 2 }

// An attempt's own status, shared by the «تلاش‌ها» and «صف بررسی» tabs
// (V9-p). `queued` is Plan B's (V9-b): stored and waiting, either for the
// requeue job or for an admin to score it by hand — without it here, a
// queued take rendered as an unlabelled badge in the attempts tab.
export const ATTEMPT_STATUS_FA = {
  pending: 'در انتظار',
  analyzing: 'در حال تحلیل',
  queued: 'در صف بررسی',
  scored: 'امتیازدهی‌شده',
  failed: 'ناموفق',
}

export const ATTEMPT_STATUS_CLS = {
  pending: 'bg-slate-100 text-slate-500',
  analyzing: 'bg-amber-100 text-amber-800',
  queued: 'bg-sky-100 text-sky-800',
  scored: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-700',
}

export const MONTHS_FA = ['ژانویه','فوریه','مارس','آوریل','مه','ژوئن','ژولای','اوت','سپتامبر','اکتبر','نوامبر','دسامبر']

// The calendar's week starts Monday (owner decision, 2026-10-13).
export const WEEK_DAYS = ['د','س','چ','پ','ج','ش','ی']

// JS getDay() → column index (Mon=0, Tue=1, …, Sat=5, Sun=6)
export const dayToCol = [6, 0, 1, 2, 3, 4, 5]

// Jalali month names, now only for the Teams/Rewards *month periods*: those
// periods are Shamsi months on the backend (`1405-07`), so their name is
// Jalali by definition. Every date the panel shows is Gregorian.
export const JALALI_MONTHS_FA = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند']
